import { Activity } from '../types/activity';
import { PlayerReport } from '../types/report';


export const shouldShowDateForHistoryEntry = (index: number, history: (Activity | PlayerReport)[]) => {
  if (index === 0) return true;

  const previousDate = history[index - 1].date.split('T')[0];
  const currentDate = history[index].date.split('T')[0];

  const previousUser = history[index - 1].userEmail;
  const currentUser = history[index].userEmail;

  return previousDate !== currentDate || previousUser !== currentUser;
};
